// Core React Imports
import React from "react";
import ReactDOM from "react-dom/client";

// Third-Party Libraries
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

// Local Imports
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store, persistor } from "./state-management/store";

// CSS/Stylesheets
import "leaflet/dist/leaflet.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
